import _ from 'lodash'

export function convertKeysForApi(params) {
  return _.mapKeys(params, (_value, key) => {
    return _.snakeCase(key)
  })
}

export function convertKeysForObject(params) {
  return _.mapKeys(params, (_value, key) => {
    if (key == '__typename') {
      return key
    } else {
      return _.camelCase(key)
    }
  })
}
